import React from 'react';
import { Link } from 'gatsby';
import $ from 'jquery';
import gsap from 'gsap';
import { TimelineMax } from 'gsap';

class MenuToggle extends React.Component {
  componentDidMount() {
    $(document).ready(function () {
      $('.menu-toggle').on('click', function () {
        $('.menu-toggle').toggleClass('active');
        $('.menu-background').toggleClass('active');
        $('.menu-background-noise').toggleClass('active');
      });
      var headerOverlay = new TimelineMax({ paused: true });
      if ($('.nsd-menu-overlay')[0]) {
        headerOne();
      }
      function headerOne() {
        gsap.set('.nsd-menu-overlay', { xPercent: 100, visibility: 'visible' });
        gsap.set('.nsd-menu-overlay__content_part__left', { yPercent: 100 });
        gsap.set(
          '.nsd-menu-overlay__content_part__left ul .fullscreen-single__item',
          { rotate: 0, y: 3, skewY: 0 }
        );
        headerOverlay
          .to(
            '.nsd-menu-overlay',
            // 0.3,
            // { className: '+=nsd-menu-overlay' }
            { xPercent: 0 }
            // (className: '+=on')
            // {
            //   css: {
            //     className: '+= nav__search--active',
            //   },
            // }
            // { }
          )
          .to(
            '.nsd-menu-overlay__content_part__left',
            0,
            { yPercent: 0 },
            '-=0'
          )
          .to(
            '.nsd-menu-overlay__content_part__left ul .fullscreen-single__item',
            { opacity: 1, rotate: 0, y: 0, skewY: 0, stagger: 0.05 },
            '-=0'
          );

        // .to(
        //   '.nsd-menu-overlay__content_part__right',
        //   0.7,
        //   { y: 0, opacity: 1 },
        //   '-=0.3'
        // );
        headerOverlay.duration(1);
        headerOverlay.reverse();

        $(document).on('click', '.menu-toggle', function () {
          headerOverlay.reversed(!headerOverlay.reversed());
        });
        $(document).on('click', 'nav .nsd-menu-fullscren li a', function () {
          headerOverlay.reversed(!headerOverlay.reversed());
          $('.menu-toggle').toggleClass('active');
          $('.menu-background').toggleClass('active');
          $('.menu-background-noise').toggleClass('active');
        });
        $(document).on('click', '.menu-background', function () {
          headerOverlay.reversed(!headerOverlay.reversed());
          $('.menu-toggle').toggleClass('active');
          $('.menu-background').toggleClass('active');
          $('.menu-background-noise').toggleClass('active');
        });
      }
    });
  }
  render() {
    return (
      <>
        <div className="menu-background"></div>
        <div className="menu-background-noise"></div>
        <div className="nsd-menu-overlay">
          <div className="container m-auto">
            <div className="nsd-menu-overlay__content flex flex-wrap overflow-hidden">
              <div className="nsd-menu-overlay__content_part nsd-menu-overlay__content_part__left">
                <ul className="nsd-menu-fullscren">
                  <li className="fullscreen-single__item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="fullscreen-single__item">
                    <Link to="/projects">
                      Project
                      <span className="projectNum">5</span>
                    </Link>
                  </li>
                  <li className="fullscreen-single__item">
                    <Link to="/company">Company</Link>
                  </li>
                  <li className="fullscreen-single__item has-sub menu-item-has-children">
                    <span className="store">(Online Store)</span>
                    <ul className="sub-menu">
                      <li className="sub-menu__inner">
                        {/* <Link to="/lemochlo">
                          Lemochlo
                          <div className="menu__lemochlo"></div>
                        </Link> */}
                        <a href="https://lemon-chlorella.com/" target="_blank">
                          Lemochlo
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="fullscreen-single__item has-sub menu-item-has-children">
                    <span className="store">(Online Store)</span>
                    <ul className="sub-menu">
                      <li className="sub-menu__inner">
                        {/* <Link to="/lemochlo">
                          Lemochlo
                          <div className="menu__lemochlo"></div>
                        </Link> */}
                        <a href="https://tampack.jp/" target="_blank">
                          Tampack
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="fullscreen-single__item">
                    <a href="mailto:hello@silencer.inc">Contact</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="header">
          <a className="menu-toggle">
            <div className="hamburger">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="cross">
              <span></span>
              <span></span>
            </div>
          </a>
        </div>
      </>
    );
  }
}

export default MenuToggle;
